import React from "react";
import Contexts from "../contexts";

const useAppLocalStorage = () => {
  return React.useContext(Contexts.StorageContext);
};

export default useAppLocalStorage;
